import { type Item, PageHeader, ViewSettings } from '@/components'
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Pagination,
  PaginationItem,
  Stack,
} from '@mui/material'
import { breadcrumbsItems } from './constants'
import { NavLink, useNavigate } from 'react-router-dom'
import { useGetCompanyListQuery, useLazyGetCompanyListQuery } from '@/api'
import AddIcon from '@mui/icons-material/Add'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { OrganizationTable } from './components/OrganizationTable'
import { createContext, useEffect, useState } from 'react'
import { type CompanyParams } from '@/api/models/company'
import { CompanyStatus } from './components/CompanyStatus'
import { StatusFilter } from './components/filters'
import { SearchIcon } from '../MedComplexList/icons'
import { useRole } from '@/hooks'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OrganizationListContext = createContext({} as any)

export const OrganizationList = () => {
  // // TODO: delete
  // const at = localStorage.getItem('accessToken')
  // const rt = localStorage.getItem('refreshToken')
  // const textEncoder = new TextEncoder()
  // const ate = textEncoder
  //   .encode(at ?? '')
  //   .toString()
  //   .replaceAll(',', '.')
  // const rte = textEncoder
  //   .encode(rt ?? '')
  //   .toString()
  //   .replaceAll(',', '.')
  // window.location.assign(
  //   'https://menu.tetron.cloud' + '/#/organisations' + `?&ate=${ate}&rte=${rte}`
  // )
  // //

  const navigate = useNavigate()
  const { access } = useRole('ORGANIZATION', ['CREATE', 'ADMIN'])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [filterQuery, setFilterQuery] = useState<any>()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [sortQuery, setSortQuery] = useState<any>()

  const [openViewSettings, setOpenViewSettings] = useState<boolean>(false)

  const [cards, setCards] = useState<Item[]>([
    {
      id: 1,
      text: 'Название организации',
      data: (item: CompanyParams) => item.short_title,
      visible: true,
      sort: (sort: 'asc' | 'desc' | '') => {
        setSortQuery({ short_title: sort })
        setSortMode(1, sort)
      },
    },
    {
      id: 2,
      text: 'Статус',
      data: (item: CompanyParams) => <CompanyStatus status={item.status} />,
      visible: true,
      sort: (sort: 'asc' | 'desc' | '') => {
        setSortQuery({ status: sort })
        setSortMode(2, sort)
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      filter: (handleClose: any, setMode: any) => (
        <StatusFilter
          setFilterRequest={setFilterQuery}
          handleClose={handleClose}
          setMode={setMode}
        />
      ),
    },
  ])

  const setSortMode = (id: number, mode: 'asc' | 'desc' | '') => {
    setCards((prev) =>
      prev.map((item: Item) =>
        item.id === id ? { ...item, sortMode: mode } : { ...item, sortMode: '' }
      )
    )
  }

  const [page, setPage] = useState<number>(1)
  const [pageQty, setPageQty] = useState(0)
  const [perPage, setPerPage] = useState<number>(50)

  // const { data: companies, refetch: refetchCompanies } = useGetCompanyListQuery(
  //   {
  //     query: JSON.stringify({
  //       page: page,
  //       per_page: perPage,
  //       orderBy: { id: 'asc' },
  //     }),
  //   }
  // )

  const [getCompanies, { data: companies }] = useLazyGetCompanyListQuery()

  useEffect(() => {
    if (page && perPage) {
      getCompanies({
        // query: JSON.stringify({
        //   page: page,
        //   per_page: perPage,
        //   //orderBy: { id: 'desc' },
        //   orderBy: sortQuery,
        //   ...filterQuery,
        // }),
        page: page,
        per_page: perPage,
        //orderBy: { id: 'desc' },
        orderBy: sortQuery,
        ...filterQuery,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      }).then((response: any) => {
        setPageQty(response?.data?.last_page)
      })
    }
  }, [page, perPage, sortQuery, filterQuery])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [typingTimer, setTypingTimer] = useState<any>()
  const typingListener = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    inputValue: any,
    typingPause: number,
    callback: () => void
  ) => {
    clearTimeout(typingTimer)
    setTypingTimer(setTimeout(callback, typingPause))
  }

  const searchRequest = (event: React.ChangeEvent<HTMLInputElement>) => {
    typingListener(event.target.value, 800, () => {
      if (event.target.value !== '') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setFilterQuery((prev: any) => ({
          ...prev,
          short_title: event.target.value,
        }))
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setFilterQuery((prev: any) => delete prev.short_title)
      }
    })
  }

  return (
    <Box>
      <PageHeader title={'Мои Организации'} />
      <Box
        sx={{
          backgroundColor: 'white',
          margin: '16px',
          padding: '16px',
          borderRadius: '4px',
        }}
      >
        <Stack gap={2}>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Box>
              <FormControl
                sx={{
                  '& .MuiInputBase-input': {
                    WebkitBoxShadow: '0 0 0 1000px white inset',
                  },
                  '& .MuiOutlinedInput-root': {
                    maxWidth: '255px',
                    minWidth: '255px',
                    maxHeight: '36px',
                    minHeight: '36px',
                    paddingRight: '6px',
                    '& input::placeholder': {
                      color: '#8E8E8E',
                      opacity: 1,
                    },
                    '& fieldset': {
                      border: '2px solid #D9D9D9',
                    },
                    '& .MuiInputAdornment-root': {
                      pointerEvents: 'none',
                    },
                    '&.MuiOutlinedInput-root:hover': {
                      opacity: 1,
                      '& fieldset': {
                        border: '2px solid #000000',
                      },
                    },
                    '&.MuiOutlinedInput-root.Mui-focused': {
                      opacity: 1,
                      '& fieldset': {
                        border: '2px solid #009FDA',
                      },
                    },
                  },
                }}
              >
                <OutlinedInput
                  placeholder="Поиск"
                  endAdornment={
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  }
                  inputProps={{ form: { autoComplete: 'off' } }}
                  autoComplete="off"
                  onChange={searchRequest}
                />
              </FormControl>
            </Box>
            <Stack direction={'row'} gap={2}>
              {access && (
                <Button
                  startIcon={<AddIcon />}
                  variant="contained"
                  onClick={() => navigate('/organization/create/general')}
                >
                  Добавить организацию
                </Button>
              )}
              <Button
                variant="contained"
                onClick={() => setOpenViewSettings(true)}
              >
                <SettingsOutlinedIcon />
              </Button>
            </Stack>
          </Stack>
          <OrganizationListContext.Provider
            value={{
              companies,
              cards,
            }}
          >
            <OrganizationTable />
            <ViewSettings
              open={openViewSettings}
              handleClose={() => setOpenViewSettings(false)}
              cards={cards}
              setCards={setCards}
            />
            <Stack
              direction={'row'}
              justifyContent={'center'}
              sx={{
                backgroundColor: '#FAFAFA',
                position: 'sticky',
                bottom: '0px',
                padding: '8px',
              }}
            >
              <Pagination
                count={pageQty}
                page={page}
                onChange={(_, num) => setPage(num)}
                variant="outlined"
                shape="rounded"
                sx={{
                  //marginY: 3, marginX: "auto",
                  '& .Mui-selected': {
                    backgroundColor: '#009FDA !important',
                    color: 'white !important',
                  },
                  '& .Mui-selected:hover': {
                    backgroundColor: 'rgb(0,159,218) !important',
                    color: 'white !important',
                  },
                }}
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    component={NavLink}
                    //to={`/medcomplex/${item.page}`}
                    to={`/organization`}
                  />
                )}
              />
            </Stack>
          </OrganizationListContext.Provider>
        </Stack>
      </Box>
    </Box>
  )
}
